<script>
    import {
        Chart as ChartJS,
        ArcElement,
        Colors,
    } from 'chart.js';
    import { Doughnut } from 'vue-chartjs';

    import ChartDataLabels from 'chartjs-plugin-datalabels';
    import ChartDoughnutLabels from 'chartjs-plugin-doughnutlabel-rebourne';

    ChartJS.register(
        ArcElement,
        Colors,
        ChartDataLabels,
        ChartDoughnutLabels,
    );

    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    // Import general mixin for shared functionality.
    import mixin from '../../mixin';

    export default {
        mixins: [mixin],
        components: {
            Doughnut,
            Vue3Autocounter,
        },
        props: {
            data: Object,
            isCurrent: Boolean,
            periods: Array,
            mostRecentYear: Number,
            secondRecentYear: Number,
        },
        data() {
            return {
                facetAlias: this.isCurrent ? 'ingangsjaar' : 'afsluitjaar',
                facetAliasTurnaround: this.isCurrent ? 'aantal_dagen_doorlooptijd_lopend' : 'aantal_dagen_doorlooptijd_afgesloten',
                options: {
                    locale: 'nl-NL',
                    cutout: '85%',
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: false,
                        },
                    },
                }
            }
        },
        computed: {
            facetsSet() {
                return this.data && this.data.facets && this.data.facets.length;
            },
            periodsSet() {
                return this.periods && this.periods.length;
            },
            dataSets() {
                const defaultValueDataset = { labels: [], datasets: [] };
                const defaultValue = [defaultValueDataset];
                if (!this.facetsSet || !this.periodsSet) return defaultValue;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return defaultValue;

                return this.periods.filter(p => p).map(period => {
                    const options = typeof period === 'number' ?
                        facet.options.filter(o => parseInt(o.valueAlias) === period) :
                        facet.options.filter(o => parseInt(o.valueAlias) != this.mostRecentYear && parseInt(o.valueAlias) != this.secondRecentYear);
                    if (!options || !options.length) return defaultValueDataset;
                    const turnaroundDays = options.map(o => o.sums[this.facetAliasTurnaround]).reduce((sum, a) => sum + a, 0);
                    const amount = options.map(o => o.filteredAmount).reduce((sum, a) => sum + a, 0);
                    const averageTurnaroundDays = turnaroundDays / amount;
                    let averageTurnaroundMonths = Math.round(averageTurnaroundDays / 30.4 * 10) / 10;
                    if (isNaN(averageTurnaroundMonths)) averageTurnaroundMonths = 0;

                    const labels = [period];
                    const data = [averageTurnaroundMonths];
                    const backgroundColor = this.$store.getters.getHighContrast ? '#833de6' : '#53b7d8';

                    if (data[0] === 0) return null;

                    return {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: backgroundColor,
                        }],
                    };
                }).filter(d => d);
            },
            optionSets() {
                return this.dataSets.map((dataSet) => {
                    return {
                        ...this.options,
                        plugins: {
                            ...this.options.plugins,
                            title: {
                                display: true,
                                text: dataSet.labels[0],
                            },
                            doughnutlabel: {
                                labels: [
                                    {
                                        text: `${dataSet.datasets[0].data[0]}`,
                                        font: {
                                            size: '16',
                                        },
                                    },
                                ]
                            }
                        },
                    };
                });
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget">
        <div class="block has-text-centered pt-2">
            <span class="is-size-10 has-text-weight-bold">{{ $store.getters.getText('dashboardWidgetTurnaround') }}</span>
        </div>
        <div class="columns is-mobile is-centered is-multiline">
            <div v-for="(data, index) in dataSets" :key="index" class="column is-half">
                <Doughnut :data="data" :options="optionSets[index]" />
            </div>
        </div>
    </div>
</template>
